<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>
<style lang="scss">
  .a-icon{
    outline: none;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .a-icon  i{
    font-size: 18px;
  }

  .vs-dropdown--custom {
    width: 220px;
  }
</style>

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right hover:text-white">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Alias')}}</label>
        <vs-input class="w-full" v-model="filters.alias" />
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Status')}}</label>
        <v-select class="align-middle" :options="state_values" v-model="filters.status" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center hidden sm:inline-block sm:w-auto">
        <vs-button @click="doFilter()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <a v-if="urlDownload.length > 0" class="btn-primary align-middle mr-2" :href="urlDownload" download="Airflow.csv"><feather-icon icon="DownloadCloudIcon" /></a>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-dropdown class="float-right align-middle mr-2 mt-2" vs-custom-content vs-trigger-click>
          <a class="a-icon" href.prevent>
            {{$t("Labels.ConfigView")}}
            <vs-icon class="" icon="expand_more"></vs-icon>
          </a>
          <vs-dropdown-menu>
            <vs-checkbox class="my-1" v-model="checkFields.alias">{{$t('Labels.Alias')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.updated_at">{{$t('Labels.Date')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.status">{{$tc('Labels.Status')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.energia">{{$tc('Labels.Energy')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.energia_a">{{$tc('Labels.Energy', 2, { n: 'A' }) + ' A'}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.energia_b">{{$tc('Labels.Energy', 2, { n: 'B' }) + ' B'}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.energia_c">{{$tc('Labels.Energy', 2, { n: 'C' }) + ' C'}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.corriente_a">{{$tc('Labels.ElectricCurrent', 2, { n: 'A' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.corriente_b">{{$tc('Labels.ElectricCurrent', 2, { n: 'B' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.corriente_c">{{$tc('Labels.ElectricCurrent', 2, { n: 'C' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.voltaje_a">{{$tc('Labels.Voltage', 2, { n: 'A' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.voltaje_b">{{$tc('Labels.Voltage', 2, { n: 'B' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.voltaje_c">{{$tc('Labels.Voltage', 2, { n: 'C' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.power_a">{{$tc('Labels.Power', 2, { n: 'A' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.power_b">{{$tc('Labels.Power', 2, { n: 'B' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.power_c">{{$tc('Labels.Power', 2, { n: 'C' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.factor_a">{{$tc('Labels.Factor', 2, { n: 'A' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.factor_b">{{$tc('Labels.Factor', 2, { n: 'B' })}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="checkFields.factor_c">{{$tc('Labels.Factor', 2, { n: 'C' })}}</vs-checkbox>
            <div class="text-center">
              <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'" @click="saveConfig()" class="bg-primary" type="filled" size="small">{{$t("Labels.Save")}}</vs-button>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'" class="align-middle mr-2" color="primary" type="filled" href="energy/costs" icon-pack="feather" icon="icon-dollar-sign">Costos</vs-button>
      </div>
    </div>
    <div id="data-list-list-view" class="data-list-container mt-2 px-">
      <vs-table v-if="response" ref="table" :data="response">
        <template>
          <tbody>
          <tr :key="index" @click="goToDetail(item.energies_id)" class="tr-values vs-table--tr tr-table-state-null selected" v-for="(item, index) in response">
              <vs-td>
                <table>
                  <tr>
                    <listItem v-if="checkFields.alias"
                      :value="item.alias"
                      :description="$t('Labels.Alias')"
                      img="energy"
                      class="font-bold"
                    ></listItem>
                    <listItem v-if="checkFields.energia"
                      :value="parseFloat(item.energia).toFixed(2)"
                      :description="$tc('Labels.Energy')"
                      img="kws"
                      unit="Wh"
                    ></listItem>
                    <listItem v-if="checkFields.updated_at"
                      :value="item.updated_at.split(' ')[0]"
                      :description="item.updated_at.split(' ')[1]"
                      img="fecha"
                    ></listItem>
                    <listAlertItem v-if="checkFields.status"
                    :status="item.status === 1? true: false"></listAlertItem>
                  </tr>
                  <tr>
                    <listItem v-if="checkFields.corriente_a"
                      :value="item.corriente_a"
                      :description="$tc('Labels.ElectricCurrent', 2, { n: 'A' })"
                      img="corriente_a"
                      unit="A"
                    ></listItem>
                    <listItem v-if="checkFields.energia_a"
                      :value="item.energia_a"
                      :description="$tc('Labels.Energy', 2, { n: 'A' }) + ' A'"
                      img="kws"
                      unit="Wh"
                    ></listItem>
                    <listItem v-if="checkFields.voltaje_a"
                      :value="item.voltaje_a"
                      :description="$tc('Labels.Voltage', 2, { n: 'A' }) + ' A'"
                      img="voltaje_a"
                      unit="V"
                    ></listItem>
                    <listItem v-if="checkFields.power_a"
                      :value="item.potencia_a"
                      :description="$tc('Labels.Power', 2, { n: 'A' }) + ' A'"
                      img="potencia_a"
                      unit="W"
                    ></listItem>
                    <listItem v-if="checkFields.factor_a"
                      :value="item.factor_a"
                      :description="$tc('Labels.Factor', 2, { n: 'A' })"
                      img="factor_a"
                    ></listItem>
                  </tr>
                  <tr>
                    <listItem v-if="checkFields.corriente_b"
                      :value="item.corriente_b"
                      :description="$tc('Labels.ElectricCurrent', 2, { n: 'B' })"
                      img="corriente_b"
                      unit="A"
                    ></listItem>
                    <listItem v-if="checkFields.energia_b"
                      :value="item.energia_b"
                      :description="$tc('Labels.Energy', 2, { n: 'B' }) + ' B'"
                      img="kws"
                      unit="Wh"
                    ></listItem>
                    <listItem v-if="checkFields.voltaje_b"
                      :value="item.voltaje_b"
                      :description="$tc('Labels.Voltage', 2, { n: 'B' }) + ' B'"
                      img="voltaje_b"
                      unit="V"
                    ></listItem>
                    <listItem v-if="checkFields.power_b"
                      :value="item.potencia_b"
                      :description="$tc('Labels.Power', 2, { n: 'B' }) + ' B'"
                      img="potencia_b"
                      unit="W"
                    ></listItem>
                    <listItem v-if="checkFields.factor_b"
                      :value="item.factor_b"
                      :description="$tc('Labels.Factor', 2, { n: 'B' })"
                      img="factor_b"
                    ></listItem>
                  </tr>
                  <tr>
                    <listItem v-if="checkFields.corriente_c"
                      :value="item.corriente_c"
                      :description="$tc('Labels.ElectricCurrent', 2, { n: 'C' })"
                      img="corriente_c"
                      unit="A"
                    ></listItem>
                    <listItem v-if="checkFields.energia_c"
                      :value="item.energia_c"
                      :description="$tc('Labels.Energy', 2, { n: 'C' }) + ' C'"
                      img="kws"
                      unit="Wh"
                    ></listItem>
                    <listItem v-if="checkFields.voltaje_c"
                      :value="item.voltaje_c"
                      :description="$tc('Labels.Voltage', 2, { n: 'C' }) + ' C'"
                      img="voltaje_c"
                      unit="V"
                    ></listItem>
                    <listItem v-if="checkFields.power_c"
                      :value="item.potencia_c"
                      :description="$tc('Labels.Power', 2, { n: 'C' }) + ' C'"
                      img="potencia_c"
                      unit="W"
                    ></listItem>
                    <listItem v-if="checkFields.factor_c"
                      :value="item.factor_c"
                      :description="$tc('Labels.Factor', 2, { n: 'C' })"
                      img="factor_c"
                    ></listItem>
                  </tr>
                </table>
              </vs-td>
          </tr>
          </tbody>
        </template>
      </vs-table>
      <vs-pagination v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import listAlertItem from '@/components/listAlertItem/listAlertItem.vue'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'

export default {
  components: {
    'v-select': vSelect,
    listItem,
    listAlertItem,
    iconBase,
    iconFilterAsc,
    iconFilterDesc,
    iconFilter
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      state_values: [
        { label: 'Todos', value: '' },
        { label: 'Correcto', value: 0 },
        { label: 'Alerta', value: 1 }
      ],
      filters: {
        limit: 20,
        offset: 0,
        byColumn: 'updated_at',
        byOrder: 'ASC',
        status: '',
        alias: ''
      },
      urlDownload: '',
      checkFields: {
        alias: false,
        energia: false,
        updated_at: false,
        energia_a: false,
        energia_b: false,
        energia_c: false,
        corriente_a: false,
        corriente_b: false,
        corriente_c: false,
        voltaje_a: false,
        voltaje_b: false,
        voltaje_c: false,
        power_a: false,
        power_b: false,
        power_c: false,
        factor_a: false,
        factor_b: false,
        factor_c: false,
        status: false
      },
      fieldsView: [],
      columnOrders: [
        { label: this.$t('Labels.Alias'), value: 'alias' },
        { label: this.$t('Labels.Status'), value: 'status' },
        { label: this.$t('Labels.Date'), value: 'updated_at' }
      ],
      byColumn: 'updated_at',
      byPage: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 75, value: 75 },
        { label: 100, value: 100 }
      ],
      showFilters: false
    }
  },
  methods: {
    async getResponse () {
      this.$vs.loading()

      const params = {
        url: 'modelo/energies',
        method: 'GET',
        params: this.filters
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.setPages(response.data.data.count)
        if (response.data.data.rows.length > 0) {
          if (response.data.data.rows[0].see_data.length > 0) {
            this.fieldsView = response.data.data.rows[0].see_data.split(',')
            this.fieldsView.forEach(element => {
              if (this.hasProperty(this.checkFields, element)) { this.checkFields[element] = true }
            })
          } else {
            for (const key in this.checkFields) {
              if (this.hasProperty(this.checkFields, key)) {
                this.checkFields[key] = true
              }
            }
          }
        }
        this.createCsv()
      }).catch(() => {
        this.response = []
        this.setPages(0)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    hasProperty (obj, key) {
      return Object.prototype.hasOwnProperty.call(obj, key)
    },
    goToDetail (uuid) {
      window.location.href = `/energy/detail/${uuid}`
    },

    createCsv () {
      const csv = []
      const headers = []
      headers.push('Alias')
      headers.push('Energía')
      headers.push('Corriente A')
      headers.push('Voltaje A')
      headers.push('Potencia A')
      headers.push('Potencia Reactiva A')
      headers.push('Factor A')
      headers.push('Corriente B')
      headers.push('Voltaje B')
      headers.push('Potencia B')
      headers.push('Potencia Reactiva B')
      headers.push('Factor B')
      headers.push('Corriente C')
      headers.push('Voltaje C')
      headers.push('Potencia C')
      headers.push('Potencia Reactiva C')
      headers.push('Factor C')
      headers.push('Fecha')
      headers.push('Alerta')
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.alias)
        row.push(item.energia + 'W')
        row.push(`${item.corriente_a}A`)
        row.push(`${item.voltaje_a}V`)
        row.push(`${item.potencia_a}W`)
        row.push(`${item.potencia_r_a}W`)
        row.push(item.factor_a)
        row.push(`${item.corriente_b}A`)
        row.push(`${item.voltaje_b}V`)
        row.push(`${item.potencia_b}W`)
        row.push(`${item.potencia_r_b}W`)
        row.push(item.factor_b)
        row.push(`${item.corriente_c}A`)
        row.push(`${item.voltaje_c}V`)
        row.push(`${item.potencia_c}W`)
        row.push(`${item.potencia_r_c}W`)
        row.push(item.factor_c)
        row.push(item.updated_at)
        row.push((item.status === 1 ? 'Alerta' : 'Correcto'))
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    async saveConfig () {
      let seeData = ''
      for (const p in this.checkFields) {
        if (this.checkFields[p] === true) seeData += `${p},`
      }
      const params = {
        url: 'modelo/energies/change_view',
        method: 'PUT',
        params: {
          see_data: seeData
        }
      }
      await request(params)
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    resetFilters () {
      this.filters.status = ''
      this.filters.alias = ''
    },
    doFilter () {
      if (this.currentx !== 1) { this.currentx = 1 } else { this.getResponse() }
    }
  },
  sockets: {
    energie (payload) {
      this.response.forEach(toModify => {
        if (toModify.energies_id === payload.uuid) {
          toModify.corriente_a = payload.corriente_a
          toModify.corriente_b = payload.corriente_b
          toModify.corriente_c = payload.corriente_c
          toModify.energia = payload.energia
          toModify.energia_a = payload.energia_a
          toModify.energia_b = payload.energia_b
          toModify.energia_c = payload.energia_c
          toModify.factor_a = payload.factor_a
          toModify.factor_b = payload.factor_b
          toModify.factor_c = payload.factor_c
          toModify.potencia_a = payload.potencia_a
          toModify.potencia_b = payload.potencia_b
          toModify.potencia_c = payload.potencia_c
          toModify.potencia_r_a = payload.potencia_r_a
          toModify.potencia_r_b = payload.potencia_r_b
          toModify.potencia_r_c = payload.potencia_r_c
          toModify.voltaje_a = payload.voltaje_a
          toModify.voltaje_b = payload.voltaje_b
          toModify.voltaje_c = payload.voltaje_c
          toModify.status = payload.status
          toModify.updated_at = payload.updated_at
        }
      })
    }
  },
  created () {
    this.getResponse()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>
